let AbstractImporter = require('../../io/import/abstractImporter');

/**
 * Класс JsonImporter
 * @extends AbstractImporter
 */

class TopoJsonImporter extends AbstractImporter{
  constructor(params){
    super(params);
  }
}

module.exports = TopoJsonImporter;